import { j as c } from "../../../jsx-runtime-B6kdoens.js";
import { a as n } from "../../../index-CROKJrb5.js";
import { c as m, f as u } from "../../../create-component-CBAeEoQ6.js";
const x = m(
  "FooterNav",
  u(
    ({ as: r, children: o, className: t, ...e }, s) => {
      const a = r || "nav";
      return /* @__PURE__ */ c.jsx(
        a,
        {
          ref: s,
          className: n(
            "cur-order-1 cur-flex cur-shrink-0 cur-grow cur-justify-between cur-gap-3 lg:cur-basis-1/3",
            t
          ),
          ...e,
          children: o
        }
      );
    }
  )
);
export {
  x as FooterNav
};
//# sourceMappingURL=index.js.map
